module.exports = __webpack_public_path__ + "img/921_part1_image2.f4d806d0.jpg";